export default __webpack_public_path__ + "static/media/star.cb76045f.png";